export default "__VITE_ASSET__b810654b__"